const styles = () => ({
  editor:{
    flex: 1,
  },
  container: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',

    '& .quill': {
      height: 'auto',
      padding: 0,
      margin: 0,
    },

    '& .ql-toolbar': {
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none'
    },

    '& .ql-container': {
      fontFamily: 'Roboto-Regular',
      border: 'none',
      overflow: 'auto',
      fontSize: '0.875rem',
      '& .ql-editor': {
        minHeight: 132,
      }
    },

    '& .ql-tooltip input': {
      outline: 'none'
    },

    '& .ql-snow .ql-tooltip.ql-editing a.ql-action::after': {
      content: "'Speichern'"
    },

    '& .ql-snow .ql-tooltip[data-mode=link]::before': {
      content: "'Link eingeben:'"
    },
    '& .ql-picker.ql-insertCustomTags .ql-picker-label::before, & .ql-picker.ql-insertCustomTags .ql-picker-item::before': {
      content: 'Custom'
    },

    '&::after': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,.1)'
    },
    pointerEvents: 'none'
  },
  enabled: {
    pointerEvents: 'auto',
    '&::after': {
      content: 'none'
    }
  },
  withoutOverlay: {
    '&::after': {
      content: 'none'
    }
  }
});

export default styles;
